import { tv } from "tailwind-variants";

import type { FormInputBaseVariants } from "~/components/formElements/formInputBaseVariant.ts";
import type { VariantProps } from "~/types/tailwindVariants";

export const switchVariants = tv({
	slots: {
		container: "flex items-center",
		button: [
			"relative inline-flex flex-shrink-0 cursor-pointer rounded-full ",
			"border-2 border-transparent ",
			"transition-colors duration-200 ease-in-out",
		],
		indicator: "pointer-events-none inline-block transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
		labelOff: "cursor-pointer",
		labelOn: "cursor-pointer",
	},
	variants: {
		textColor: {
			default: {
				container: "text-gray-900",
			},
			light: {
				container: "text-gray-700",
			},
		},
		inputSize: {
			xs: {
				button: "h-5 w-8",
				container: "gap-x-2 text-xs",
				indicator: "size-4",
			},
			sm: {
				button: "h-6 w-11",
				container: "gap-x-3 text-sm",
				indicator: "size-5",
			},
			md: {
				button: "h-6 w-11",
				container: "gap-x-3 text-sm",
				indicator: "size-5",
			},
		},
		checked: {
			true: {
				button: "bg-primary-400",
				indicator: "translate-x-5",
				labelOn: "text-gray-900",
			},
			false: {
				button: "bg-gray-200",
				indicator: "translate-x-0",
				labelOff: "text-gray-900",
			},
		},
		focusRing: {
			true: {
				button: "focus:ring-2 focus:ring-blue-500",
			},
		},
		reverseLabels: {
			true: {
				container: "flex-row-reverse",
			},
			false: {
				container: "flex-row",
			},
		},
		showAllLabels: {
			true: {
				labelOff: "",
				labelOn: "",
				container: "text-gray-400",
			},
			false: {
				labelOff: "hidden",
			},
		},
	},
	compoundSlots: [
		{
			slots: ["indicator"],
			inputSize: "xs",
			checked: true,
			className: "translate-x-3",
		},
		{
			slots: ["labelOn"],
			checked: false,
			showAllLabels: true,
			className: "text-gray-400",
		},
		{
			slots: ["labelOff"],
			checked: true,
			showAllLabels: true,
			className: "text-gray-400",
		},
	],
	defaultVariants: {
		checked: false,
		inputSize: "md",
		text: "left",
		textColor: "default",
		focusRing: true,
		showAllLabels: false,
		reverseLabels: false,
	},
});

export type SwitchVariantsProps = VariantProps<typeof switchVariants> & FormInputBaseVariants;